class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-body',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: "main-cart-subtotal",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents-subtotal",
      },
      {
        id: "main-cart-subtotal-mobile",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents-subtotal-mobile",
      }
    ];
  }

  getSectionsToRenderWhenAdd() {
    return [
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents-body',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: "main-cart-subtotal",
        section: 'main-cart-items',
        selector: ".js-contents-subtotal",
      },
      {
        id: "main-cart-subtotal-mobile",
        section: 'main-cart-items',
        selector: ".js-contents-subtotal-mobile",
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        // free shipping
        let freeshippingEl = [...document.querySelectorAll("free-shipping")];
        freeshippingEl.forEach(el => {
          el.setAttribute("total", Math.round(parsedState.total_price/100));
        });

        // cart upsell
        let cartUpsell = document.querySelector("cart-upsell");
        if (cartUpsell) cartUpsell.calcTriggeredItem(parsedState.items);
        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.renderContents(parsedState);

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch((e) => {
        console.log("error", e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {

    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  renderContents(parsedState, addAPI) {
    let selectedSectionsToRender = addAPI ? this.getSectionsToRenderWhenAdd : this.getSectionsToRender;
    selectedSectionsToRender().forEach((section => {
      const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  static get observedAttributes() {
    return ["triggeritem"];
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    this.changeHandler();
  }

  async init() {
    this.bodyCont = this.querySelector("[cart-upsell-body-item]");

    // fetch data from app later
    this.getTriggerInfo();
    await this.getProductData();
    await this.calcTriggeredItem();
    this.changeHandler();
  }

  changeHandler() {
    this.triggerItem = this.getAttribute("triggeritem");
    this.render();
  }

  getTriggerInfo() {
    this.triggerRule = {
      "Classic / Pivo Pod Lite": [
        "Classic / Pivo Pod Lite + Remote Control",
        "Classic / Pivo Pod Lite + Starter Kit",
        "Silver / Pivo Pod",
        "Silver / Pivo Pod + Starter Kit",
        "Pivo Pod",
        "Pivo Pod + Starter Kit",
      ],
      "Classic / Pivo Pod Lite + Remote Control": [
        "Classic / Pivo Pod Lite + Starter Kit",
        "Classic / Pivo Pod Lite + Essential Kit",
        "Silver / Pivo Pod + Starter Kit",
        "Silver / Pivo Pod + Essential Kit",
        "Pivo Pod + Starter Kit",
        "Pivo Pod + Essential Kit",
      ],
      "Classic / Pivo Pod Lite + Starter Kit": [
        "Classic / Pivo Pod Lite + Essential Kit",
        "Silver / Pivo Pod + Starter Kit",
        "Silver / Pivo Pod + Essential Kit",
        "Pivo Pod + Starter Kit",
        "Pivo Pod + Essential Kit",
      ],
      "Classic / Pivo Pod Lite + Essential Kit": [
        "Travel Case Classic",
        "Silver / Pivo Pod + Essential Kit",
        "Pivo Pod + Essential Kit",
        "Pivo Pod Solo Creator Edition",
      ],
    };
    this.triggerPriority = [
      "Classic / Pivo Pod Lite",
      "Classic / Pivo Pod Lite + Remote Control",
      "Classic / Pivo Pod Lite + Starter Kit",
      "Classic / Pivo Pod Lite + Essential Kit",
    ];
    this.triggerItem = "";
  }

  async getProductData() {
    // should be changed to fetch product data later
    const PodLite = await fetch("/products/pivo-pod-lite.js").then((res) =>
      res.json()
    );
    const PodLiteClassic = PodLite.variants.filter((variant) =>
      variant.title.includes("Classic")
    );

    let obj = PodLiteClassic.reduce((prev, item, index) => {
      return {
        ...prev,
        [item.title]: {
          ...item,
          link: `/products/${PodLite.handle}?variant=${item.id}`,
          featured_image: item.featured_image.src,
        },
      };
    }, {});

    const PodActive = await fetch("/products/pivo-pod.js").then((res) =>
      res.json()
    );
    const PodActiveSilver = PodActive.variants;

    obj = PodActiveSilver.reduce((prev, item, index) => {
      return {
        ...prev,
        [item.title]: {
          ...item,
          link: `/products/${PodActive.handle}?variant=${item.id}`,
          featured_image: item.featured_image.src,
        },
      };
    }, obj);

    let TravelCaseClassic = await fetch(
      "/products/travel-case-classic.js"
    ).then((res) => res.json());
    let TravelCaseClassicVariant = TravelCaseClassic.variants[0];
    TravelCaseClassic = {
      ...TravelCaseClassicVariant,
      link: `/products/${TravelCaseClassic.handle}?variant=${TravelCaseClassicVariant.id}`,
      featured_image: TravelCaseClassic.featured_image,
    };

    let SoloCreatorEdition = await fetch(
      "/products/solo-creator-edition.js"
    ).then((res) => res.json());
    let SoloCreatorEditionVariant = SoloCreatorEdition.variants[0];
    SoloCreatorEdition = {
      ...SoloCreatorEditionVariant,
      link: `/products/${SoloCreatorEdition.handle}?variant=${SoloCreatorEditionVariant.id}`,
      featured_image: SoloCreatorEdition.featured_image,
    };

    this.upsellItems = {
      ...obj,
      [TravelCaseClassic.name]: TravelCaseClassic,
      [SoloCreatorEdition.name]: SoloCreatorEdition,
    };
  }

  async calcTriggeredItem(items) {
    let cartItems = items;
    if (!cartItems) {
      cartItems = await this.getCart();
      cartItems = cartItems.items;
    }

    let triggerItemIndex = -1;
    cartItems.forEach((item) => {
      let curIndex = this.triggerPriority.findIndex((cur) =>
        item.variant_title
          ? cur == item.variant_title
          : cur == item.product_title
      );
      if (curIndex || curIndex == 0) {
        if (triggerItemIndex < curIndex) {
          triggerItemIndex = curIndex;
        }
      }
    });

    this.setAttribute("triggeritem", this.triggerPriority[triggerItemIndex]);
  }

  async getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  render() {
    if (this.triggerRule[this.triggerItem]) {
      let wireframe = `<slider-component class="slider-mobile-gutter">
        <ul id="Slider-{{ section.id }}" class="grid product-grid contains-card contains-card--standard grid--${
          this.triggerRule[this.triggerItem].length
        }-col-desktop grid--2-col-tablet-down" role="list">
          {replace}
        </ul>
      </slider-component>`;

      let newCardHTML = this.triggerRule[this.triggerItem].reduce(
        (prev, current, index) => {
          if (!this.upsellItems[current]) return prev;

          let { link, compare_at_price, id, price, name, featured_image } =
            this.upsellItems[current];

          let el = `
          <li class="grid__item slider__slide">
            <div class="card-wrapper underline-links-hover" style="height: 100%;">
              <div class="card card--standard card--media" style="--ratio-percent: 100.0%; height: 100%; display: flex; flex-direction: column;">
                <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <img style="transform: scale(0.8);" src=${featured_image} alt="${name}" class="motion-reduce" loading="lazy" width="3000" height="3000">
                    </div>
                  </div>
                </div>
                <div class="card__content" style="margin-top: 4px; flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                  <div class="card__information">
                    <h3 style="font-weight: 500 !important; line-height: 1.2 !important;" class="card__heading typography--body3">
                      <a href="${link}" class="full-unstyled-link" aria-labelledby="CardLink-template--14413396181074__360a7584-16f2-4839-a6df-5ff1fae1a355-6888956067922 Badge-template--14413396181074__360a7584-16f2-4839-a6df-5ff1fae1a355-6888956067922">
                        ${name}
                      </a>
                    </h3>
                    <div class="card-information" style="margin-top: 4px;">
                      <div class="dawn-text_color--selected price typography--body3 price--on-sale" main-product-price-cont badge-handler-cont>
                        <div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular" main-product-price-price=""> ${this.money_format(
                              price
                            )} </span>
                          </div>
                          <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last" main-product-price-price=""> ${this.money_format(
                              price
                            )} </span>
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span>
                              <s class="price-item price-item--regular" main-product-price-compare_at_price=""> ${this.money_format(
                                compare_at_price
                              )} </s>
                            </span>
                          </div>
                          <small class="unit-price caption hidden">
                            <span class="visually-hidden">Unit price</span>
                            <span class="price-item price-item--last">
                              <span></span>
                              <span aria-hidden="true">/</span>
                              <span class="visually-hidden">&nbsp;per&nbsp;</span>
                              <span></span>
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="quick-add">
                    <product-form>
                      <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓">
                        <input type="hidden" name="id" value="${id}">
                        <!--<input type="hidden" name="properties[UpsellType]" value="cart-recommendation">-->
                        <button type="submit" name="add" class="button button--full-width button--primary" style="margin-top: 15px;" aria-haspopup="dialog" aria-labelledby="quick-add-template-submit title-template--14413396181074__360a7584-16f2-4839-a6df-5ff1fae1a355-6888956067922" aria-live="polite" data-sold-out-message="true">
                          <span>Add to cart </span>
                          <span class="sold-out-message hidden"> Sold out </span>
                          <div class="loading-overlay__spinner hidden">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </form>
                    </product-form>
                  </div>
                </div>
              </div>
            </div>
          </li>
        `;

          return prev + el;
        },
        ""
      );

      this.bodyCont.innerHTML = wireframe.replace("{replace}", newCardHTML);
    }

    if (!this.triggerRule[this.triggerItem]) {
      this.classList.add("display-none");
    } else {
      this.classList.remove("display-none");
    }
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  money_format(priceNum) {
    return CURRENCY + this.numberWithCommas(priceNum / 100);
  }

  money_format_floor(priceNum) {
    return CURRENCY + this.numberWithCommas(Math.floor(priceNum / 100));
  }
}

customElements.define("cart-upsell", CartUpsell);
